import React from 'react';
import withAuth from 'app/blocks/common/withAuth';
import { navigateToDashboard } from 'app/blocks/middleware/dashboard';
import { getUrlParam, invalidateUrlParam } from 'app/blocks/middleware/url-params';

function withUnauthRequiredPage<P>(Component: React.ComponentType<P>): React.ComponentType<P> {
    return function (props: P & { isAuth: boolean; location2?: Location }) {
        if (!props.isAuth) {
            return <Component {...props} />;
        }

        const { location2 = window.location } = props;
        const returnUrl = getUrlParam('returnUrl');
        // fixme - probably we should check returnUrl outside?
        if (returnUrl) {
            invalidateUrlParam('returnUrl');
            location2.replace(returnUrl);
        } else {
            navigateToDashboard();
        }

        return null;
    };
}

function withExplicitLoginPage<P>(Component: React.ComponentType<P>): React.ComponentType<P> {
    return function (props: P & { isAuth: boolean; location2?: Location }) {
        if (!props.isAuth) {
            return <Component {...props} />;
        }
        return null;
    };
}

const withExplicitLogin = Component => withAuth(withExplicitLoginPage(Component));

export { withExplicitLogin, withExplicitLoginPage, withUnauthRequiredPage };
export default Component => withAuth(withUnauthRequiredPage(Component));
